import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { PlanHorarioReglas } from '../models/planHorarioReglas';
import { environment } from '../../environments/environment';

const baseUrl = environment.hostService + '/planHorarioTrabajoReglas';

@Injectable({
  providedIn: 'root'
})
export class PlanHorarioReglasService {

  constructor(private _http: HttpClientService) { }

  getAll(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/Index' })
  }

  save(entidad: PlanHorarioReglas)
  {
    return this._http.post({ url: baseUrl + '/Save', body: entidad });
  }

  delete(id: number)
  {
    return this._http.get<any>({ url: baseUrl + '/Delete?id=' + id });   
  }
}

